export default "__VITE_ASSET__DsdJAO2F__"